import { useState } from "react";

import vehicleSubjectChange, { SignatureDto } from "serverApi/vehicleSubjectChange";
import { vehicleDigiSignApi } from "serverApi";
import { SubjectTypeEnum } from "types";

export type DigisignEligibleResponse = {
    isEligible: boolean;
    subjectType?: SubjectTypeEnum;
    phoneNumber?: string;
    email?: string;
};

export default function useDigisign(idObject, idChange) {
    const [isDigisignEligibilityLoading, setIsDigisignEligibilityLoading] = useState(false);
    const [digisignEligibilityData, setDigisignEligibilityData] = useState<DigisignEligibleResponse>({ isEligible: false });

    const [isSigning, setIsSigning] = useState(false);
    const [isSignInitializationFailed, setIsSignInitializationFailed] = useState(false);

    const checkDigisignEligibility = async () => {
        setIsDigisignEligibilityLoading(true);

        const [error, res] = await vehicleDigiSignApi.checkDigisignEligibility(idChange);

        if (error) {
            setDigisignEligibilityData({ isEligible: false });
            setIsDigisignEligibilityLoading(false);
            return;
        }

        if (res.ok && res.body) {
            const response: DigisignEligibleResponse = res.body;

            const eligibilityData = {
                isEligible: response?.isEligible === true,
                subjectType:
                    response?.subjectType?.toUpperCase() === SubjectTypeEnum.COMPANY ? SubjectTypeEnum.COMPANY : SubjectTypeEnum.INDIVIDUAL,
                phoneNumber: response?.phoneNumber,
                email: response?.email,
            };

            setDigisignEligibilityData(eligibilityData);
            setIsDigisignEligibilityLoading(false);
        }
    };

    const signDocument = async () => {
        setIsSigning(true);
        setIsSignInitializationFailed(false);

        const dto: SignatureDto = {
            idObject: idObject,
            redirectUrl: window.location.href,
        };

        const [error, res] = await vehicleDigiSignApi.sign(idChange, dto);

        if (error) {
            setIsSignInitializationFailed(true);
            setIsSigning(false);
            return;
        }

        if (res.ok && res.body) {
            if (!res) return;
            const redirectUrl = res.body.signRedirectUrl;
            window.location.href = redirectUrl;
        }
    };

    return {
        digisignEligibilityData,
        checkDigisignEligibility,
        isDigisignEligibilityLoading,

        signDocument,
        isSigning,
        isSignInitializationFailed,
    };
}
